<!-- eslint-disable i18next/no-literal-string -->
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="mc-sidebar-liveview__fleet">
    <div>
      <div class="mc-sidebar-liveview__filter mc-sidebar-trackvision__filter">
        <b-row v-if="!search.licensePlate">
          <b-col md="12">
            <button
              :class="
                fleetFilterStatus.all
                  ? 'mc-sidebar-liveview__filter-btn mc-sidebar__filter-btn-trackvision mc-sidebar-liveview__filter-btn--primary'
                  : 'mc-sidebar-liveview__filter-btn mc-sidebar__filter-btn-trackvision'
              "
              :disabled="$store.state.video.loadingFleets"
              @click="showAll()"
            >
              {{ $t('global.filter.all') }}
            </button>
            <button
              :class="
                fleetFilterStatus.running
                  ? 'mc-sidebar-liveview__filter-btn mc-sidebar__filter-btn-trackvision mc-sidebar-liveview__filter-btn--success'
                  : 'mc-sidebar-liveview__filter-btn mc-sidebar__filter-btn-trackvision'
              "
              :disabled="$store.state.video.loadingFleets"
              @click="updateFilterStatus('running')"
            >
              {{ $t('global.filter.running') }}
            </button>
            <button
              :class="
                fleetFilterStatus.idle
                  ? 'mc-sidebar-liveview__filter-btn mc-sidebar__filter-btn-trackvision mc-sidebar-liveview__filter-btn--warning'
                  : 'mc-sidebar-liveview__filter-btn mc-sidebar__filter-btn-trackvision'
              "
              :disabled="$store.state.video.loadingFleets"
              @click="updateFilterStatus('idle')"
            >
              {{ $t('global.filter.idle') }}
            </button>
            <button
              :class="
                fleetFilterStatus.parking
                  ? 'mc-sidebar-liveview__filter-btn mc-sidebar__filter-btn-trackvision mc-sidebar-liveview__filter-btn--danger'
                  : 'mc-sidebar-liveview__filter-btn mc-sidebar__filter-btn-trackvision'
              "
              :disabled="$store.state.video.loadingFleets"
              @click="updateFilterStatus('parking')"
            >
              {{ $t('global.filter.parking') }}
            </button>
            <button
              v-if="hasAccess(['assisted_motion_status:read'])"
              :class="
                fleetFilterStatus.assisted
                  ? 'mc-sidebar-liveview__filter-btn mc-sidebar__filter-btn-trackvision mc-sidebar__filter-btn-assisted mc-sidebar-liveview__filter-btn--info'
                  : 'mc-sidebar-liveview__filter-btn mc-sidebar__filter-btn-trackvision mc-sidebar__filter-btn-assisted'
              "
              :disabled="$store.state.video.loadingFleets"
              @click="updateFilterStatus('assisted')"
            >
              {{ $t('liveView.filter.assisted') }}
            </button>
            <button
              :class="
                fleetFilterStatus.offline
                  ? 'mc-sidebar-liveview__filter-btn mc-sidebar__filter-btn-trackvision mc-sidebar-trackvideo__filter-btn-offline mc-sidebar-liveview__filter-btn--dark'
                  : 'mc-sidebar-liveview__filter-btn mc-sidebar__filter-btn-trackvision mc-sidebar-trackvideo__filter-btn-offline'
              "
              :disabled="$store.state.video.loadingFleets"
              @click="updateFilterStatus('offline')"
            >
              {{ $t('global.filter.offline') }}
            </button>
          </b-col>
        </b-row>
      </div>

      <b-row class="mc-sidebar-liveview__search-wrapper mc-sidebar-trackvision__search-wrapper">
        <b-col md="8">
          <b-input-group class="mt-2 mc-sidebar-liveview__search" @click="focusSearch">
            <template #prepend>
              <b-input-group-text>
                <i class="icon-outline_search"></i>
              </b-input-group-text>
            </template>
            <b-form-input
              v-model="search.licensePlate"
              ref="searchInput"
              type="search"
              :placeholder="`${$t('global.search')}...`"
              :disabled="$store.state.video.loadingFleets"
              @input="searchVehicle()"
            />
          </b-input-group>
        </b-col>

        <b-col md="4" class="text-end pe-2">
          <a
            id="sortFleetBtn"
            href="#"
            class="btn btn-outline-primary mx-2"
            @click="sortPopover = !sortPopover"
          >
            <i class="mc-fa icon-fill_height"></i>
          </a>
          <b-popover
            ref="popover"
            target="sortFleetBtn"
            triggers="click"
            :show.sync="sortPopover"
            placement="leftbottom"
          >
            <b-list-group class="mc-list-group-item">
              <b-list-group-item
                :active="orderActive == 2 ? true : false"
                :disabled="$store.state.video.loadingFleets"
                @click="sortBy('licensePlate', 'asc', 'notdate', 2)"
              >
                {{ $t('global.object.licensePlate') }}: ASC
              </b-list-group-item>
              <b-list-group-item
                :active="orderActive == 3 ? true : false"
                :disabled="$store.state.video.loadingFleets"
                @click="sortBy('licensePlate', 'desc', 'notdate', 3)"
              >
                {{ $t('global.object.licensePlate') }}: DESC
              </b-list-group-item>
              <b-list-group-item
                :active="orderActive == 4 ? true : false"
                :disabled="$store.state.video.loadingFleets"
                @click="sortBy('calculatedMotionStatus', 'asc', 'notdate', 4)"
              >
                {{ $t('global.object.fleetStatus') }}: ASC
              </b-list-group-item>
              <b-list-group-item
                :active="orderActive == 5 ? true : false"
                :disabled="$store.state.video.loadingFleets"
                @click="sortBy('calculatedMotionStatus', 'desc', 'notdate', 5)"
              >
                {{ $t('global.object.fleetStatus') }}: DESC
              </b-list-group-item>
            </b-list-group>
          </b-popover>

          <a
            href="#"
            class="btn btn-outline-primary"
            :class="!showHideDetail ? 'mc-expand' : 'mc-collapse'"
            :disabled="$store.state.video.loadingFleets"
            @click="checkDetailVehicleList"
          >
            <i class="mc-fa icon-fill_expand"></i>
            <i class="mc-fa icon-outline_collapse"></i>
          </a>
        </b-col>

        <b-col v-if="!$store.state.video.loadingFleets" md="12">
          <div class="mc-sidebar-liveview__filter-show row my-2">
            <div class="col-sm-12">
              {{ $t('global.show') }}
              <strong>{{ status.moving + status.idle + status.parking + status.offline }}</strong>
              {{ $t('global.text.vehicleData') }}
              <span v-if="status.moving">
                <strong>{{ status.moving }}</strong> {{ $t('global.filter.running') }}
              </span>
              <span v-if="status.idle">
                <strong> {{ status.idle }}</strong> {{ $t('global.filter.idle') }}
              </span>
              <span v-if="status.parking">
                <strong> {{ status.parking }}</strong> {{ $t('global.filter.parking') }}
              </span>
              <span v-if="status.assisted">
                <strong> {{ status.assisted }}</strong> {{ $t('liveView.filter.assisted') }}
              </span>
              <span v-if="status.offline">
                <strong> {{ status.offline }}</strong> {{ $t('global.filter.offline') }}
              </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <div v-if="$store.state.video.loadingFleets" class="mc-sidebar--loading">
      <b-spinner label="Loading..." />
    </div>

    <b-list-group
      v-if="!$store.state.video.loadingFleets"
      class="mc-sidebar-liveview__list-fleet mc-sidebar-trackvideo__list-fleet"
    >
      <template v-if="renderList">
        <!-- eslint-disable vue/no-use-v-if-with-v-for -->
        <b-list-group-item
          v-for="(row, index) in dataByStatus"
          v-if="row.showInList"
          :id="`vehicle-${row.vehicleId}`"
          :key="row.vehicleId"
          :class="[
            {
              selected: row.selected,
            },
            'mc-sidebar-liveview_list_fleet_container',
          ]"
        >
          <div
            class="mc-sidebar-liveview_list_fleet_checkbox mc-sidebar-trackvision_list_fleet_checkbox"
          >
            <b-form-checkbox
              :id="`checkbox-${row.vehicleId}`"
              v-model="dataByStatus[index].checked"
              :class="{
                'mc-sidebar-liveview-checkbox--disabled':
                  !row.statusText ||
                  getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'O' ||
                  getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'U',
              }"
              :disabled="
                !row.statusText ||
                getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'O' ||
                getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'U'
              "
              @change="checkedPickVehicle(row, index)"
            />
          </div>

          <div class="mc-sidebar-liveview_list-fleet-detail-wrapper">
            <div class="clearfix mc-sidebar-liveview_list-fleet-top-wrapper">
              <span
                v-b-tooltip.hover
                class="mc-trackvision-sidebar__license-plate"
                :class="{
                  'pull-left': true,
                  'mc-sidebar-liveview-button--disabled':
                    getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'O' ||
                    getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'U',
                }"
                :title="
                  getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'O' ||
                  getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'U'
                    ? $t('trackVideo.deviceOffline')
                    : ''
                "
                @click="pickVehicle(row, index)"
              >
                {{
                  row.parent?.vehicle ? row.parent?.vehicle?.licensePlate : row.vehicle.licensePlate
                }}
              </span>
              <div class="mc-sidebar-liveview_list-fleet-top-badge-wrapper">
                <b-badge
                  v-if="getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'M'"
                  class="bg-success"
                  :title="$t('global.filter.running')"
                >
                  {{ $t('global.filter.running') }}
                </b-badge>
                <b-badge
                  v-else-if="
                    getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'I'
                  "
                  class="bg-warning"
                  :title="$t('global.filter.idle')"
                >
                  {{ $t('global.filter.idle') }}
                </b-badge>
                <b-badge
                  v-else-if="
                    getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'P'
                  "
                  class="bg-danger"
                  :title="$t('global.filter.parking')"
                >
                  {{ $t('global.filter.parking') }}
                </b-badge>
                <b-badge
                  v-else-if="
                    getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'O'
                  "
                  class="bg-secondary"
                  :title="$t('global.filter.offline')"
                >
                  {{ $t('global.filter.offline') }}
                </b-badge>
                <b-badge
                  v-else-if="
                    getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'U'
                  "
                  class="bg-secondary"
                  :title="$t('global.filter.offline')"
                >
                  {{ $t('global.filter.offline') }}
                </b-badge>
                <b-badge
                  v-else-if="
                    getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'A'
                  "
                  class="bg-info"
                  :title="$t('liveView.filter.assisted')"
                >
                  {{ $t('liveView.filter.assisted') }}
                </b-badge>
                <template
                  v-if="
                    (row.vehicle.device.deviceType === 'bsj' ||
                      row.vehicle.device.deviceType === 'vss-howen') &&
                    hasAccess(['b3f-two-way-communication:read'])
                  "
                >
                  <b-button
                    v-if="!vehicleIdsCallActive.includes(row.vehicleId)"
                    v-b-tooltip.hover
                    class="mc-sidebar-liveview_button-video-play mc-sidebar-trackvideo__btn-call"
                    :class="{
                      disabled:
                        (vehicleIdsCallActive.length >= $store.state.voip.maxCall &&
                          !vehicleIdsCallActive.includes(row.vehicleId)) ||
                        getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'U' ||
                        getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'O' ||
                        $store.state.voip.isBroadcastActive,
                    }"
                    :title="$t('trackVideo.callDriver')"
                    @click="handleClickStartCall(row)"
                  >
                    <i class="mc-fa icon-outline_phone"></i>
                  </b-button>
                  <!-- Button for stop call -->
                  <b-button
                    v-else
                    v-b-tooltip.hover
                    class="mc-sidebar-liveview_button-video-play active"
                    :title="$t('trackVideo.endCall')"
                    @click="handleClickEndCall(row)"
                  >
                    <i class="mc-fa icon-outline_phone-off"></i>
                  </b-button>
                </template>
                <b-button
                  v-b-tooltip.hover
                  :title="$t('trackVideo.videoHistory')"
                  class="mc-sidebar-liveview_button-video-play"
                  :disabled="
                    !row.statusText ||
                    getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'O' ||
                    getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'U'
                  "
                  @click="goToHistory(row)"
                >
                  <i class="mc-fa icon-outline_video-history"></i>
                </b-button>
              </div>
            </div>

            <div v-if="showHideDetail" class="mc-sidebar-liveview__list-fleet-showhide">
              <div
                v-if="$store.state.video.fleetListDisplay.label_hull && row.vehicle.hullNo"
                class="mc-sidebar-liveview__list-fleet-showhide-wrapper"
              >
                <span>
                  <i class="mc-fa icon-outline_license-general"></i>
                  {{ row.vehicle.hullNo }}
                </span>
              </div>
              <div class="mc-sidebar-liveview__list-fleet-showhide-wrapper">
                <span v-if="$store.state.video.fleetListDisplay.label_classification">
                  <i class="mc-fa icon-outline_bus"></i>
                  <template
                    v-if="$store.state.video.fleetListDisplay.classification_type == 'category'"
                  >
                    {{
                      row.vehicle.vehicleType
                        ? row.vehicle.vehicleType.category
                        : $t('global.text.noCategory')
                    }}
                  </template>
                  <template
                    v-else-if="$store.state.video.fleetListDisplay.classification_type == 'type'"
                  >
                    {{ row.vehicle.vehicleType.type }}
                  </template>
                  <template v-else>{{ row.vehicle.vehicleType.manufacturer }}</template>
                </span>
                <span v-if="$store.state.video.fleetListDisplay.label_driver">
                  <i class="mc-fa icon-outline_person"></i>
                  {{
                    row.parent
                      ? row.parent?.vehicle?.driver1?.fullname ?? $t('global.text.noDriver')
                      : row.vehicle.driver1
                      ? row.vehicle.driver1.fullname
                      : $t('global.text.noDriver')
                  }}
                </span>
              </div>

              <b-card v-if="row.statusText" border-variant="light" no-body class="border">
                <div class="d-flex flex-row">
                  <!--  eslint-disable-next-line vue/singleline-html-element-content-newline -->
                  <div class="p-2">{{ $t('trackVideo.camera') }} :</div>
                  <div class="pt-2 mc-channel-wrapper">
                    <b-form-checkbox-group
                      v-model="row.playlist"
                      :disabled="
                        getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'O' ||
                        getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus === 'U'
                      "
                      class="clearfix"
                      :options="row.channel"
                      plain
                      @change="(e) => checkPlaylist(row, index, e)"
                    />
                  </div>
                </div>
              </b-card>
            </div>
          </div>
        </b-list-group-item>
      </template>
    </b-list-group>

    <button
      class="mc-sidebar-liveview__list-notif-more btn btn-outline-primary"
      @click="goToDownloadVideoHistory"
    >
      <i class="mc-fa icon-outline_download"></i> {{ $t('trackVideo.historyVideoDownload') }}
    </button>
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'
import { mapActions, mapGetters, mapState } from 'vuex'
import responsive from '@/mixin/responsive'
import { MixPanel } from '@/mixin/mixpanel'
import { v4 as uuidv4 } from 'uuid'
import WorkerTv2 from 'worker-loader!../lib/worker.js'
import { GET_PAYLOAD } from '@/services/api/auth'

export default {
  name: 'ListFleet',
  mixins: [Helper, responsive, MixPanel],
  data() {
    return {
      search: {
        licensePlate: null,
      },
      orderBy: {
        objName: 'licensePlate',
        order: 'asc',
        type: 'string',
      },
      orderActive: 2,
      fleetFilterStatus: {
        all: true,
        running: false,
        idle: false,
        parking: false,
        offline: false,
        assisted: false,
      },
      status: {
        moving: 0,
        idle: 0,
        offline: 0,
        parking: 0,
        assisted: 0,
      },
      dataByStatus: [],
      sortPopover: false,
      showHideDetail: true,
      renderList: false,
      payloadWsFlespiHowen: null,
      wsMessageHandler: null,
      intervalUpdateDataFromWs: null,
    }
  },
  computed: {
    ...mapGetters('video', [
      'fleetsListFilter',
      'fleetsList',
      'tempVehicleStatusByVehicleId',
      'vehicleStatusByVehicleId',
      'flespiHowenVehicleIds',
    ]),
    ...mapGetters('voip', ['vehicleIdsCallActive']),
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      hasAccess: 'identity/hasAccess',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    ...mapState('video', ['workerTrackvision']),
    vehicleIds() {
      return this.fleetsList.map((item) => item.vehicleId)
    },
    isUsingWsFlv() {
      return (deviceCode) => {
        const featureHubWsFlvCompanyId = this.getFeatureFlagValue('trackvision_list_company_ws_flv')
        if (featureHubWsFlvCompanyId.length === 0) return false
        if (this.getDeviceType(deviceCode) === 'jc') {
          return false
        }
        return featureHubWsFlvCompanyId.includes(this.$store.state.identity.whoami?.companyId)
      }
    },
  },
  watch: {
    dataByStatus: function (_) {
      this.filterSearch()
    },
    async '$store.state.video.lastClosedPlaylist'(lastClosedPlaylist) {
      if (lastClosedPlaylist === null) return
      const arr = lastClosedPlaylist.split(':')
      const vehicleId = Number(arr[0])
      const indexDataByStatus = this.dataByStatus.findIndex((item) => item.vehicleId === vehicleId)

      const oldVehicle = { ...this.dataByStatus[indexDataByStatus] }

      this.dataByStatus[indexDataByStatus].oldPlaylist = oldVehicle.tempPlaylist ?? []
      const newPlaylist = oldVehicle.playlist.filter((playlist) => playlist !== lastClosedPlaylist)

      this.dataByStatus[indexDataByStatus].playlist = newPlaylist
      this.dataByStatus[indexDataByStatus].tempPlaylist = newPlaylist
      this.dataByStatus[indexDataByStatus].oldPlaylistWithUid = oldVehicle?.playlistWithUid ?? []
      await this.$nextTick()
      this.dataByStatus[indexDataByStatus].playlistWithUid = this.dataByStatus[
        indexDataByStatus
      ].playlistWithUid.filter((data) => {
        return data.playlist !== lastClosedPlaylist
      })
      await this.$nextTick()
      if (this.dataByStatus[indexDataByStatus].playlist.length === 0) {
        this.dataByStatus[indexDataByStatus].checked = false
      }
    },
  },

  async mounted() {
    try {
      const self = this

      this.initWorker()
      await this.loadData()
      await this.setupWebsocket()

      this.$root.$on('refreshFleets', function () {
        self.refreshFleets()
      })

      this.intervalUpdateDataFromWs = setInterval(() => {
        if (this.$store.state.ws.socket.isConnected && this.workerTrackvision) {
          this.workerTrackvision.postMessage({
            action: 'calculatedVehicleStatuses',
            tempData: JSON.stringify(this.$store.state.video.tempVehicleStatuses),
            data: JSON.stringify(this.$store.state.video.vehicleStatuses),
          })
        }
      }, 4000)

      if (this.hasAccess(['b3n-trackvision-toggle-video-status:read'])) {
        this.track('Live Streaming List Without Video Status', {
          companyId: this.$store.state.identity.whoami?.companyId,
        })
      }

      // handle autoPlay basedOn queryParams vehicleId
      let vehicleId = this.$route.query.vehicleId
      if (vehicleId) {
        vehicleId = Number(vehicleId)
        const vehicle = this.dataByStatus.find((item) => item.vehicleId === vehicleId)
        vehicle.checked = true
        if (!vehicle) return
        this.checkedPickVehicle(vehicle)
      }
    } catch (error) {
      this.$mcToast.error(error?.message ?? this.$t('global.somethingWentWrong'))
      console.log(error)
    }
  },
  async beforeDestroy() {
    if (this.wsMessageHandler) {
      this.$store.dispatch('ws/unregisterMessageHandler', this.wsMessageHandler)
    }
  },
  destroyed() {
    // Terminate the worker when the component is destroyed
    if (this.workerTrackvision) {
      this.workerTrackvision.terminate()
    }
    clearInterval(this.intervalUpdateDataFromWs)
  },
  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },

    ...mapActions('video', ['requestFleets', 'setVideoStreamStatus', 'setVehicleTypeAndVgroups']),

    checkIsDemo(vehicleId) {
      const dataDemoTrackvision = this.getFeatureFlagValue('vsms2_trackvision2_stream_demo_id')

      return Object.keys(dataDemoTrackvision)
        .map((id) => parseInt(id))
        .includes(vehicleId)
    },

    getVehicleStatusByVehicleId(vehicleId) {
      if (this.checkIsDemo(vehicleId)) {
        return {
          ...this.vehicleStatusByVehicleId(vehicleId),
          calculatedMotionStatus: 'M',
        }
      }
      return this.vehicleStatusByVehicleId(vehicleId)
    },

    getDeviceIsOffline(vehicleId) {
      let secondEngineOn = 60
      let secondEngineOff = 600
      if (this.getFeatureFlagValue('trackvision_video_offline_acc_on')) {
        secondEngineOn = this.getFeatureFlagValue('trackvision_video_offline_acc_on')
      }
      if (this.getFeatureFlagValue('trackvision_video_offline_acc_off')) {
        secondEngineOff = this.getFeatureFlagValue('trackvision_video_offline_acc_off')
      }

      if (this.checkIsDemo(vehicleId)) {
        return false
      }
      const lastReceive = this.getVehicleStatusByVehicleId(vehicleId).lastReceive
      const engineOn = this.getVehicleStatusByVehicleId(vehicleId).engineOn
      const diffMinutes = this.getDurationBetween2Dates(lastReceive, this.nowUtc())
      if (engineOn) {
        return diffMinutes > secondEngineOn / 60
      }
      return diffMinutes > secondEngineOff / 60
    },

    async initWorker() {
      if (typeof Worker !== 'undefined') {
        this.$store.commit('video/setWorkerTrackvision', new WorkerTv2())
        await this.$nextTick()
        this.workerTrackvision.onmessage = async (event) => {
          const { action, result } = event.data
          if (action === 'updateVehicleStatuses') {
            this.$store.commit('video/setVehicleStatuses', JSON.parse(result))
            await this.$nextTick()
            this.$store.commit('video/resetTempVehicleStatuses')
            this.$forceUpdate()
          }
        }
      }
    },

    async loadData() {
      this.$store.commit('video/loadingFleets', true)
      this.dataByStatus = []
      this.renderList = false
      await this.requestFleets({
        filter: {
          motionStatus: this.hasAccess(['assisted_motion_status:read'])
            ? ['assisted', 'idle', 'moving', 'offline', 'parking', 'unknown']
            : undefined,
        },
      })
      this.setVehicleStatuses()
      // TODO : Uncomment this when flespi ready
      // if (this.flespiHowenVehicleIds?.length) {
      //   await this.getPayloadFlespiHowen()
      //   await this.startWebSocketFlespiHowen()
      // }
      this.$store.commit('video/ORDER_BY', this.orderBy)
      if (!this.fleetFilterStatus.all) {
        this.filterByStatus()
      } else {
        this.dataByStatus = this.fleetsListFilter(this.search.licensePlate).map((data) => ({
          ...data,
          showInList: true,
        }))
      }

      this.setVehicleTypeAndVgroups()

      this.renderList = true
      this.$store.commit('video/loadingFleets', false)
    },

    calculatedTempWsData(vehicleId, data) {
      let calculatedMotionStatus = data.calculatedMotionStatus

      if (data.calculatedMotionStatus === 'A' && !this.hasAccess(['assisted_motion_status:read'])) {
        calculatedMotionStatus = 'P'
      }

      this.$store.commit('video/setTempVehicleStatusesByVehicleId', {
        vehicleId,
        data: {
          ...this.tempVehicleStatusByVehicleId(vehicleId),
          lastReceive: data.lastReceive,
          latitude: data.latitude,
          longitude: data.longitude,
          calculatedMotionStatus,
          engineOn: data.engineOn,
        },
      })
    },

    async setupWebsocket() {
      this.wsMessageHandler = this.handleWebSocketMessage.bind(this)
      await this.$store.dispatch('ws/registerMessageHandler', this.wsMessageHandler)

      this.ensureWebSocketConnected()
    },
    async ensureWebSocketConnected() {
      try {
        const wsToken = localStorage.getItem('wsToken')
        const payload = localStorage.getItem('payload')
        if (!wsToken) return

        // Use centralized WebSocket connection
        // ws/WSConnect already handles all connection logic and waiting
        if (!this.$store.state.ws.socket.isConnected) {
          const wsUrl = `${process.env.VUE_APP_WS_URL}/ws?token=${wsToken}`
          // WSConnect returns a promise that resolves when connected
          // It handles race conditions and waits for ongoing connections automatically
          await this.$store.dispatch('ws/WSConnect', wsUrl)
        }

        // Send payload if connected and not already initialized
        // Only send if App.vue hasn't already sent the initial payload
        if (
          this.$store.state.ws.socket.isConnected &&
          payload &&
          !this.$store.state.ws.isInitialized
        ) {
          this.$store.dispatch('ws/updateTags', payload)
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to ensure WebSocket connection:', error)
      }
    },
    handleWebSocketMessage(message) {
      const signal = typeof message === 'string' ? JSON.parse(message) : message

      if (signal.type.startsWith('gps-')) {
        const vehicleId = Number(signal.type.slice(4))
        if (!this.vehicleIds.includes(vehicleId)) return
        this.calculatedTempWsData(vehicleId, signal.payload)
      }
    },
    async setVehicleStatuses() {
      this.fleetsList.forEach((v) => {
        this.$store.commit('video/setVehicleStatusesByVehicleId', {
          vehicleId: v.vehicleId,
          data: {
            calculatedMotionStatus: v.calculatedMotionStatus,
            lastReceive: v.lastReceive,
            engineOn: v.engineOn,
          },
        })
      })
    },
    refreshFleets() {
      if (!this.fleetFilterStatus.all) {
        this.filterByStatus()
      } else {
        this.dataByStatus = this.fleetsListFilter(this.search.licensePlate)
      }
    },
    async showAll() {
      let obj = { ...this.fleetFilterStatus }
      Object.keys(obj).forEach(function (key) {
        if (key !== 'all') {
          obj[key] = false
        } else {
          obj[key] = true
        }
      })
      this.fleetFilterStatus = obj
      await this.$nextTick()
      setTimeout(() => {
        this.dataByStatus = this.dataByStatus.map((data) => ({
          ...data,
          showInList: true,
        }))
      }, 300)
    },

    checkDetailVehicleList() {
      this.showHideDetail = !this.showHideDetail
      if (this.showHideDetail) {
        this.track('Maximize Vehicle List in Track Video')
      } else {
        this.track('Minimize Vehicle List in Track Video')
      }
    },

    async updateFilterStatus(param) {
      this.fleetFilterStatus[param] = !this.fleetFilterStatus[param]
      this.fleetFilterStatus.all = false
      await this.$nextTick()
      let obj = { ...this.fleetFilterStatus }
      let objArr = []
      Object.keys(obj).forEach(function (key) {
        if (obj[key]) {
          objArr.push(true)
        }
      })

      const selectAll = this.hasAccess(['assisted_motion_status:read'])
        ? objArr.length === 5
        : objArr.length === 4

      if (selectAll || objArr.length === 0) {
        this.showAll()
      } else {
        this.filterByStatus()
      }
    },

    filterSearch() {
      const running = this.dataByStatus.filter(
        (fleet) =>
          this.getVehicleStatusByVehicleId(fleet.vehicleId).calculatedMotionStatus === 'M' &&
          fleet.showInList
      )
      this.status.moving = running.length

      const idle = this.dataByStatus.filter(
        (fleet) =>
          this.getVehicleStatusByVehicleId(fleet.vehicleId).calculatedMotionStatus === 'I' &&
          fleet.showInList
      )
      this.status.idle = idle.length

      const parking = this.dataByStatus.filter(
        (fleet) =>
          this.getVehicleStatusByVehicleId(fleet.vehicleId).calculatedMotionStatus === 'P' &&
          fleet.showInList
      )

      this.status.parking = parking.length

      const offline = this.dataByStatus.filter(
        (fleet) =>
          (this.getVehicleStatusByVehicleId(fleet.vehicleId).calculatedMotionStatus === 'O' &&
            fleet.showInList) ||
          (this.getVehicleStatusByVehicleId(fleet.vehicleId).calculatedMotionStatus === 'U' &&
            fleet.showInList)
      )
      this.status.offline = offline.length

      const assisted = this.dataByStatus.filter(
        (fleet) =>
          this.getVehicleStatusByVehicleId(fleet.vehicleId).calculatedMotionStatus === 'A' &&
          fleet.showInList
      )
      this.status.assisted = assisted.length
    },

    filterDataStatusBySearch() {
      let result
      if (!this.search.licensePlate) {
        result = this.dataByStatus.map((data) => ({
          ...data,
          showInList: true,
        }))
      } else {
        result = this.dataByStatus.map((data) => {
          const licensePlate = data.parent?.vehicle
            ? data?.parent?.vehicle?.licensePlate
            : data.vehicle.licensePlate
          const isMatchLicensePlate = licensePlate
            ?.toLowerCase()
            .match(this.search.licensePlate?.toLowerCase())
          const driverFullname = data.parent
            ? data.parent?.vehicle?.driver1?.fullname
            : data.vehicle?.driver1?.fullname
          const isMatchDriverFullname = driverFullname
            ?.toLowerCase()
            .match(this.search.licensePlate?.toLowerCase())
          if (isMatchLicensePlate || isMatchDriverFullname) {
            return {
              ...data,
              showInList: true,
            }
          }
          return {
            ...data,
            showInList: false,
          }
        })
      }
      return result
    },

    async searchVehicle() {
      this.dataByStatus = this.filterDataStatusBySearch()
      this.$forceUpdate()
    },

    filterByStatus() {
      let result = this.filterDataStatusBySearch()

      let data = []

      this.status.moving = 0
      if (this.fleetFilterStatus.running) {
        const running = result.filter(
          (fleet) =>
            this.getVehicleStatusByVehicleId(fleet.vehicleId).calculatedMotionStatus === 'M'
        )
        data.push(...running)
        this.status.moving = running.length
      }

      this.status.idle = 0
      if (this.fleetFilterStatus.idle) {
        const idle = result.filter(
          (fleet) =>
            this.getVehicleStatusByVehicleId(fleet.vehicleId).calculatedMotionStatus === 'I'
        )
        data.push(...idle)
        this.status.idle = idle.length
      }

      this.status.parking = 0
      if (this.fleetFilterStatus.parking) {
        const parking = result.filter(
          (fleet) =>
            this.getVehicleStatusByVehicleId(fleet.vehicleId).calculatedMotionStatus === 'P'
        )
        data.push(...parking)
        this.status.parking = parking.length
      }

      this.status.offline = 0
      if (this.fleetFilterStatus.offline) {
        const offline = result.filter(
          (fleet) =>
            this.getVehicleStatusByVehicleId(fleet.vehicleId).calculatedMotionStatus === 'O' ||
            this.getVehicleStatusByVehicleId(fleet.vehicleId).calculatedMotionStatus === 'U'
        )
        data.push(...offline)
        this.status.offline = offline.length
      }

      this.status.assisted = 0
      if (this.fleetFilterStatus.assisted) {
        const assisted = result.filter(
          (fleet) =>
            this.getVehicleStatusByVehicleId(fleet.vehicleId).calculatedMotionStatus === 'A'
        )
        data.push(...assisted)
        this.status.assisted = assisted.length
      }

      setTimeout(() => {
        this.dataByStatus = result.map((res) => {
          if (data.some((d) => d.vehicleId === res.vehicleId)) {
            return {
              ...res,
              showInList: true,
            }
          }
          return {
            ...res,
            showInList: false,
          }
        })
        this.$forceUpdate()
      }, 200)
    },

    getDataStatusByOrderBy() {
      const tempData = [...this.dataByStatus]
      if (this.orderBy.objName === 'licensePlate') {
        if (this.orderBy.order === 'asc') {
          tempData.sort((a, b) => {
            const aLicensePlate = a.parent?.vehicle
              ? a.parent.vehicle?.licensePlate
              : a.vehicle.licensePlate
            const bLicensePlate = b.parent?.vehicle
              ? b.parent.vehicle?.licensePlate
              : b.vehicle.licensePlate
            return aLicensePlate > bLicensePlate ? 1 : bLicensePlate > aLicensePlate ? -1 : 0
          })
        } else {
          tempData.sort((a, b) => {
            const aLicensePlate = a.parent?.vehicle
              ? a.parent?.vehicle?.licensePlate
              : a.vehicle.licensePlate
            const bLicensePlate = b.parent?.vehicle
              ? b.parent?.vehicle?.licensePlate
              : b.vehicle.licensePlate
            return bLicensePlate > aLicensePlate ? 1 : aLicensePlate > bLicensePlate ? -1 : 0
          })
        }
      } else if (this.orderBy.objName === 'calculatedMotionStatus') {
        if (this.orderBy.order === 'asc') {
          tempData.sort((a, b) =>
            this.getVehicleStatusByVehicleId(a.vehicleId).calculatedMotionStatus >
            this.getVehicleStatusByVehicleId(b.vehicleId).calculatedMotionStatus
              ? 1
              : this.getVehicleStatusByVehicleId(b.vehicleId).calculatedMotionStatus >
                this.getVehicleStatusByVehicleId(a.vehicleId).calculatedMotionStatus
              ? -1
              : 0
          )
        } else {
          tempData.sort((a, b) =>
            this.getVehicleStatusByVehicleId(b.vehicleId).calculatedMotionStatus >
            this.getVehicleStatusByVehicleId(a.vehicleId).calculatedMotionStatus
              ? 1
              : this.getVehicleStatusByVehicleId(a.vehicleId).calculatedMotionStatus >
                this.getVehicleStatusByVehicleId(b.vehicleId).calculatedMotionStatus
              ? -1
              : 0
          )
        }
      }
      return tempData
    },

    sortBy(objName, order, type, active) {
      this.orderBy = {
        objName: objName,
        order: order,
        type: type,
      }

      this.dataByStatus = this.getDataStatusByOrderBy()

      this.orderActive = active
      this.sortPopover = !this.sortPopover

      this.track('Sort Vehicle List in Track Video', { sort: order, parameter: objName })

      this.$forceUpdate()
    },

    pickVehicle(data, index) {
      this.renderList = false
      this.dataByStatus[index].selected = !this.dataByStatus[index].selected
      this.renderList = true
    },

    async checkedPickVehicle(data) {
      this.resetQueryParamsVehicleId()
      if (this.getDeviceIsOffline(data.vehicleId) && data.checked) {
        data.playlist = data.channel.map((x) => x.value)
        data.tempPlaylist = data.channel.map((x) => x.value)

        await this.delay(200)

        data.playlist = []
        data.tempPlaylist = []
        data.checked = false

        this.$mcToast.error(this.$t('trackVideo.deviceUnreachable'))
        return
      }
      const oldData = { ...data }
      data.oldPlaylist = oldData.tempPlaylist ?? []

      if (data.checked === false) {
        data.playlist = []
        data.tempPlaylist = []
        this.track('Unchecked: Stop Video Streaming')
      } else {
        data.playlist = data.channel.map((x) => x.value)
        data.tempPlaylist = data.channel.map((x) => x.value)
        this.track('Checked: Play Video Streaming')
      }
      await this.$nextTick()

      data.oldPlaylistWithUid = oldData?.playlistWithUid ?? []
      await this.$nextTick()
      data.playlistWithUid = data.playlist.map((playlist) => {
        const isOldPlaylist = data.oldPlaylistWithUid.some((data) => data.playlist === playlist)
        if (isOldPlaylist) {
          return {
            playlist,
            uid: data.oldPlaylistWithUid.find((data) => data.playlist === playlist).uid,
          }
        }
        return { playlist, uid: uuidv4() }
      })

      const usingWsFlv = this.isUsingWsFlv(data.vehicle.device.deviceCode)

      let channelSent = data.playlist.map((p) =>
          this.getDeviceType(data.vehicle.device.deviceCode) === 'jc'
            ? (parseInt(p.split(':')[1]) + 1).toString()
            : p.split(':')[1]
        ),
        channelNotSent = []

      if (!usingWsFlv) {
        const { channelSent: _channelSent, channelNotSent: _channelNotSent } =
          await this.setVideoStreamStatus(data)
        channelSent = _channelSent
        channelNotSent = _channelNotSent
      }
      const dataDemoTrackvision = this.getFeatureFlagValue('vsms2_trackvision2_stream_demo_id')
      const isVideoDemo = Object.keys(dataDemoTrackvision).includes(data.vehicleId.toString())

      const isAllChannelNotSent =
        data.channel.length === data.playlist.length &&
        channelNotSent.length === data.channel.length &&
        channelSent.length === 0

      const deviceType = this.getDeviceType(data.vehicle.device.deviceCode)

      const isJc = deviceType === 'jc'
      if (!isVideoDemo && data.checked && isAllChannelNotSent) {
        data.checked = false

        await this.$nextTick()

        data.playlist = []
        data.tempPlaylist = []
        data.playlistWithUid = []
        data.oldPlaylist = oldData.oldPlaylist ?? []
        data.oldPlaylistWithUid = oldData.oldPlaylistWithUid ?? []
        this.$mcToast.error(this.$t('videoHistory.video.playbackOrStreamingGoinOn'))
      }
      if (
        !isVideoDemo &&
        data.checked &&
        channelNotSent.length &&
        channelNotSent.length < data.channel.length
      ) {
        const _playlist = channelSent.map(
          (channel) => `${data.vehicleId}:${isJc ? parseInt(channel) - 1 : channel}`
        )
        data.playlist = _playlist
        data.tempPlaylist = _playlist
        await this.$nextTick()
        data.playlistWithUid = data.playlistWithUid.filter((playlistUid) =>
          data.playlist.includes(playlistUid.playlist)
        )
        data.oldPlaylist = oldData.oldPlaylist ?? []
        data.oldPlaylistWithUid = oldData.oldPlaylistWithUid ?? []
        this.$mcToast.error(this.$t('videoHistory.video.playbackOrStreamingGoinOn'))
      }
      this.$forceUpdate()
      this.$store.commit('video/setLastClosedPlaylist', null)
      this.$store.commit('video/setPlaylist', { dataVehicle: data, usingWsFlv })
    },

    async checkPlaylist(data, index, values) {
      this.resetQueryParamsVehicleId()
      const oldData = { ...this.dataByStatus[index] }
      this.dataByStatus[index].oldPlaylist = oldData.tempPlaylist ?? []
      this.dataByStatus[index].playlist = values
      this.dataByStatus[index].tempPlaylist = values
      if (
        this.dataByStatus[index].playlist.length > this.dataByStatus[index].oldPlaylist.length &&
        this.getDeviceIsOffline(this.dataByStatus[index].vehicleId)
      ) {
        await this.delay(200)

        this.dataByStatus[index].playlist = this.dataByStatus[index]?.oldPlaylist ?? []
        this.dataByStatus[index].tempPlaylist = this.dataByStatus[index]?.oldPlaylist ?? []
        this.$mcToast.error(this.$t('trackVideo.deviceUnreachable'))
        return
      }
      if (this.dataByStatus[index].playlist.length === 0) this.dataByStatus[index].checked = false
      else this.dataByStatus[index].checked = true
      await this.$nextTick()
      if (this.dataByStatus[index].checked) {
        this.track('Checked: Play Video Streaming')
      } else {
        this.track('Unchecked: Stop Video Streaming')
      }

      // Get prev uncheck
      let prevUncheck
      if (this.dataByStatus[index].playlist.length < this.dataByStatus[index].oldPlaylist.length) {
        prevUncheck = this.dataByStatus[index].oldPlaylist.find(
          (playlist) => !this.dataByStatus[index].playlist.includes(playlist)
        )
      }

      this.dataByStatus[index].oldPlaylistWithUid = oldData?.playlistWithUid ?? []
      await this.$nextTick()

      this.dataByStatus[index].playlistWithUid = this.dataByStatus[index].playlist.map(
        (playlist) => {
          const isOldPlaylist = this.dataByStatus[index].oldPlaylistWithUid.some(
            (data) => data.playlist === playlist
          )
          if (isOldPlaylist) {
            return {
              playlist,
              uid: this.dataByStatus[index].oldPlaylistWithUid.find(
                (data) => data.playlist === playlist
              ).uid,
            }
          }
          return { playlist, uid: uuidv4() }
        }
      )

      const dataDemoTrackvision = this.getFeatureFlagValue('vsms2_trackvision2_stream_demo_id')

      const isVideoDemo = Object.keys(dataDemoTrackvision).includes(
        this.dataByStatus[index].vehicleId.toString()
      )

      let channelSent = this.dataByStatus[index].playlist.map((data) =>
          this.getDeviceType(this.dataByStatus[index].vehicle.device.deviceCode) === 'jc'
            ? (parseInt(data.split(':')[1]) + 1).toString()
            : data.split(':')[1]
        ),
        channelNotSent = []

      const usingWsFlv = this.isUsingWsFlv(this.dataByStatus[index].vehicle.device.deviceCode)

      if (!usingWsFlv) {
        const { channelSent: _channelSent, channelNotSent: _channelNotSent } =
          await this.setVideoStreamStatus(this.dataByStatus[index])
        channelSent = _channelSent
        channelNotSent = _channelNotSent
      }

      const deviceType = this.getDeviceType(this.dataByStatus[index].vehicle.device.deviceCode)

      if (values.length) {
        const isJc = deviceType === 'jc'
        const prevChannelActive = this.dataByStatus[index].oldPlaylist.map((playlist) =>
          isJc ? (parseInt(playlist.split(':')[1]) + 1).toString() : playlist.split(':')[1]
        )

        const channelCanPlay = [
          ...channelSent,
          ...prevChannelActive.filter((data) => channelNotSent.includes(data)),
        ]

        const _playlistCanPlay = channelCanPlay.map(
          (channel) =>
            `${this.dataByStatus[index].vehicleId}:${isJc ? parseInt(channel) - 1 : channel}`
        )
        this.dataByStatus[index].playlist = _playlistCanPlay
        this.dataByStatus[index].tempPlaylist = _playlistCanPlay
        await this.$nextTick()
        if (!isVideoDemo && _playlistCanPlay.length < values.length) {
          this.dataByStatus[index].playlistWithUid = this.dataByStatus[
            index
          ].playlistWithUid.filter((playlistUid) =>
            this.dataByStatus[index].playlist.includes(playlistUid.playlist)
          )
          this.dataByStatus[index].oldPlaylist = oldData.oldPlaylist ?? []
          this.dataByStatus[index].oldPlaylistWithUid = oldData.oldPlaylistWithUid ?? []
          this.$mcToast.error(this.$t('videoHistory.video.playbackOrStreamingGoinOn'))
        }
        if (!isVideoDemo && !_playlistCanPlay.length) {
          this.dataByStatus[index].checked = false
        }
      }

      this.$forceUpdate()

      this.$store.commit('video/setLastClosedPlaylist', null)
      this.$store.commit('video/setPlaylist', {
        dataVehicle: this.dataByStatus[index],
        usingWsFlv,
      })
    },

    async handleClickStartCall(data) {
      if (this.getDeviceIsOffline(data.vehicleId)) {
        this.$mcToast.error(this.$t('trackVideo.deviceUnreachable'))
        return
      }
      this.track('VoIP Admin make a call')
      this.$store.commit('voip/setIsTwoWayActive', true)
      const deviceType = this.getDeviceType(
        this.fleetsList.find((item) => item.vehicle.id == data.vehicleId).vehicle.device.deviceCode
      )
      this.$store.dispatch('voip/startNewCall', {
        dataNewCall: {
          vehicleId: data.vehicleId,
          licensePlate: data.parent
            ? data.parent?.vehicle?.licensePlate
            : data.vehicle.licensePlate,
          driver: data.parent
            ? data.parent?.vehicle?.driver1?.fullname ?? null
            : data.vehicle.driver1?.fullname ?? null,
          imei: data.vehicle.imei,
          deviceType,
        },
      })
    },

    async handleClickEndCall(data) {
      this.$store.dispatch('voip/endCall', { vehicleId: data.vehicleId })
    },

    goToHistory(row) {
      const path = window.location.pathname.split('/')
      const isFromMenuTrackvision = path[1] === 'live-streaming'
      if (isFromMenuTrackvision) {
        return this.goToHistoryTrackvision(row)
      }
      this.goToHistoryOld(row)
    },

    goToHistoryTrackvision(row) {
      setTimeout(() => {
        this.$router.push({
          name: 'Video History Trackvision',
          query: { vehicleId: row.vehicleId },
        })
        this.track('Open Trackvision Video History from Live Streaming')
      }, 500)
    },

    goToHistoryOld(row) {
      const deviceName = this.getDeviceType(row.vehicle.device.deviceCode)
      const payload = {
        licensePlate: row.vehicle.licensePlate,
        vehicleType: row.vehicle.vehicleType.type,
        vehicleCategory: row.vehicle.vehicleType.category,
        imei: row.vehicle.imei,
        deviceName,
        id: row.vehicle.id,
      }
      this.$store.commit('vehicle/setVehicleDetail', payload)

      this.track('Open Video History')
      const pathName = window.location.pathname.split('/')[1]

      setTimeout(() => {
        this.$router.push({
          name:
            pathName === 'live-streaming'
              ? 'Video History Trackvision Download'
              : 'Video History 3',
          params: { vehicleId: row.vehicleId, entryPoint: 'Sidebar' },
        })
      }, 500)
    },

    goToDownloadVideoHistory() {
      const path = window.location.pathname.split('/')
      const isFromMenuTrackvision = path[1] === 'live-streaming'
      this.track('Open Video Download History')
      if (isFromMenuTrackvision) {
        this.$router.push({
          name: 'Video History Trackvision Download',
          query: { prevPage: 'live-streaming' },
        })
      } else {
        this.$router.push({ name: 'Video History 3 Download' })
      }
    },

    async getPayloadFlespiHowen() {
      const variables = {
        filter: {
          filterByType: ['VideoStream'],
          videoStreamVehicleIds: this.flespiHowenVehicleIds.map((vehicleId) => {
            return {
              vehicleId,
              channel: this.$store.state.video.fleets
                .find((fleet) => fleet.vehicleId === vehicleId)
                .statusText.split(',')
                .map((p) => parseInt(p)),
            }
          }),
        },
      }
      const res = await this.$apollo.query({
        query: GET_PAYLOAD,
        fetchPolicy: 'no-cache',
        variables,
      })

      this.payloadWsFlespiHowen = res.data.getPayload.payload.payload
    },

    async startWebSocketFlespiHowen() {
      if (this.payloadWsFlespiHowen) {
        const obj = {
          type: 'update_tags',
          data: this.payloadWsFlespiHowen,
        }
        await this.$store.dispatch(
          'ws/WSConnect',
          `${process.env.VUE_APP_WS_URL}/ws?token=${localStorage.getItem('wsToken')}`
        )
        this.$socket.onopen = () => {
          this.$socket.sendObj(obj)
        }
        this.$socket.onmessage = (dataWs) => {
          const data = JSON.parse(dataWs.data)
          if (data.type.startsWith('video-stream-')) {
            const vehicleId = this.fleetsList.find(
              (fleet) => fleet.vehicle.imei === data.payload.ident
            ).vehicleId
            const channel = data.payload.response.channel
            this.$store.commit('video/addMapFlespiHowenState', {
              playlistId: `${vehicleId}:${channel}`,
              url: data.payload.response.hls,
            })
          }
        }
        this.$socket.onclose = async () => {}
      }
    },

    resetQueryParamsVehicleId() {
      const vehicleId = this.$route.query.vehicleId
      if (vehicleId) {
        this.$router.replace({
          name: this.$route.name,
          query: {
            ...this.$route.query,
            vehicleId: undefined,
          },
        })
      }
    },
  },
}
</script>
